import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import "./DemandApproval.css";
import { apiurl } from "../../../../../path";
import Application from "../../../StateContext/Application.js";
import {
  ApprovePay32,
  BillApprovalBlue32,
} from "../../../../../public/LoginImages/importimages.js";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
import { jwtDecode } from "jwt-decode";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import GooglePagination from "../../../styles/GooglePagination";
import validateFile from "../../../../../utils/fileUploadHelper.js";

// showSpecific values:
//   0 = Bill table
//   1 = Division summary  (State only)
//   2 = Deduction detail  (any role)
//   3 = District summary  (State only, after clicking a Division)

const OldDemandApproval = () => {
  const { t } = useLanguage();
  const operation = useContext(Application);
  const {
    GetOldBillsApproval,
    ApproveBills,
    GetTotalAmountAvailbaleInBank,
    Usermenu,
    Getyears,
    GetOldBillStateSummary, // ← new context function
  } = operation;

  // ── Auth ─────────────────────────────────────────────────────────────────
  const [AdminData, setAdminData] = useState({});

  useEffect(() => {
    const token = localStorage.getItem("Token");
    if (token) {
      try {
        setAdminData(jwtDecode(token));
      } catch {}
    }
  }, []);

  // ── Data ──────────────────────────────────────────────────────────────────
  const [ALLtableData, setALLTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const ALLtableDataRef = useRef([]);
  useEffect(() => {
    ALLtableDataRef.current = ALLtableData;
  }, [ALLtableData]);

  console.log("ALLtableData: ", ALLtableData);

  // Division / District summary (State roles)
  const [districtSummary, setDistrictSummary] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");

  // View state
  const [showSpecific, setShowSpecific] = useState(0);
  const [selectedDemandID, setSelectedDemandID] = useState(null);
  const [fetchDeductionDetail, setFetchDeductionDetail] = useState([]);

  // Selection
  const [selectedBills, setSelectedBills] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [uploadOrderFile, setUploadOrderFile] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  // Misc
  const [loading, setLoading] = useState(false);
  const [BankBalance, setBankBalance] = useState({});
  const [data, setData] = useState({
    ProjectID: "",
    ApprovedYear: "",
    SelectedDemandAmount: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const billsPerPage = showAll ? tableData.length || 1 : 10;
  const totalPages = Math.ceil(tableData.length / billsPerPage);
  const indexOfLast = currentPage * billsPerPage;
  const indexOfFirst = indexOfLast - billsPerPage;
  const currentBills = tableData.slice(indexOfFirst, indexOfLast);
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [
    fetchSpecificDemandDeductionDetail,
    setfetchSpecficDemandDeductionDetail,
  ] = useState([]);

  const approvedYears = [
    ...new Set(ALLtableData?.map((item) => item.AAYear).filter((year) => year)),
  ].sort();

  // ── Derived: Division summary from districtSummary ───────────────────────
  const divisionSummary = useMemo(() => {
    const map = {};
    districtSummary.forEach((item) => {
      const div = item.Division || "Unknown";
      if (!map[div])
        map[div] = {
          Division: div,
          TotalPendingCount: 0,
          TotalPendingAmount: 0,
          RDDCheckerCount: 0,
          RDDCheckerAmount: 0,
          RDDSOCount: 0,
          RDDSOAmount: 0,
        };
      map[div].TotalPendingCount += Number(item.TotalPendingCount || 0);
      map[div].TotalPendingAmount += Number(item.TotalPendingAmount || 0);
      map[div].RDDCheckerCount += Number(item.RDDCheckerCount || 0);
      map[div].RDDCheckerAmount += Number(item.RDDCheckerAmount || 0);
      map[div].RDDSOCount += Number(item.RDDSOCount || 0);
      map[div].RDDSOAmount += Number(item.RDDSOAmount || 0);
    });
    return Object.values(map);
  }, [districtSummary]);

  const DemandDeductionDetailByBillID = async (ID) => {
    try {
      let res = await Getyears("FetchDemandDeductionDetailbyBillID", ID);
      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(ID);
      setShowSpecific(2);
    } catch (err) {
      console.log(err);
    }
  };

  const filteredDistricts = districtSummary.filter(
    (d) => d.Division === selectedDivision,
  );

  // ── Fetch ─────────────────────────────────────────────────────────────────
  const FetchData = async () => {
    try {
      const bills = await GetOldBillsApproval();
      setALLTableData(bills);

      if (AdminData?.Department_Name === "State") {
        // Also fetch division/district summary
        const summaryRes = await GetOldBillStateSummary();
        setDistrictSummary(summaryRes?.message || []);
        // State users start on Division summary view
        setShowSpecific(1);
      } else {
        setTableData(bills);
        setShowSpecific(0);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        const res = await Usermenu();
        setAdminData(res.Data);
        const bal = await GetTotalAmountAvailbaleInBank();
        setBankBalance(bal?.[0] || {});
      } catch (err) {
        console.log(err);
      }
    };
    init();
  }, []);

  useEffect(() => {
    if (AdminData?.Department_Name) FetchData();
  }, [AdminData?.Department_Name]);

  // ── Navigation ────────────────────────────────────────────────────────────
  const HandleDivisionClick = (division) => {
    setSelectedDivision(division);
    setShowSpecific(3);
  };

  const HandleDistrictClick = (district) => {
    setSelectedBills([]);
    setSelectAll(false);
    setCurrentPage(1);
    setSelectedDistrict(district);
    const filtered = ALLtableDataRef.current.filter(
      (b) => b.District === district,
    );
    setTableData(filtered);
    setShowSpecific(0);
  };

  // ── Select / Approve ──────────────────────────────────────────────────────
  const handleCheckboxChange = (id) => {
    const bill = tableData.find((b) => b.DemandGenerationID === id);
    const amount = Number(bill?.BillAmount || 0);

    setSelectedBills((prev) => {
      const selectedObjs = tableData.filter((b) =>
        prev.includes(b.DemandGenerationID),
      );
      if (prev.length > 0 && !prev.includes(id)) {
        if (selectedObjs[0]?.District !== bill.District) {
          alert("You can select bills from the same district only!");
          return prev;
        }
      }
      if (prev.includes(id)) {
        setData((d) => ({
          ...d,
          SelectedDemandAmount: d.SelectedDemandAmount - amount,
        }));
        return prev.filter((x) => x !== id);
      } else {
        setData((d) => ({
          ...d,
          SelectedDemandAmount: d.SelectedDemandAmount + amount,
        }));
        return [...prev, id];
      }
    });
  };

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    let valid = currentBills;
    // if (AdminData.Department_Name === "State" && AdminData.RoleID !== 24) {
    //   valid = currentBills.filter((b) => uploadedFiles[b.DemandGenerationID]);
    // }
    // if (checked && new Set(valid.map((b) => b.District)).size > 1) {
    //   alert("Please select bills from the same district only!");
    //   return;
    // }
    const validIDs = valid.map((b) => b.DemandGenerationID);
    setSelectAll(checked);
    if (checked) {
      const newSel = [...new Set([...selectedBills, ...validIDs])];
      const newAmount = valid
        .filter((b) => !selectedBills.includes(b.DemandGenerationID))
        .reduce((s, b) => s + Number(b.BillAmount || 0), 0);
      setSelectedBills(newSel);
      setData((d) => ({
        ...d,
        SelectedDemandAmount: d.SelectedDemandAmount + newAmount,
      }));
    } else {
      const rem = selectedBills.filter((id) => !validIDs.includes(id));
      const remAmount = valid.reduce(
        (s, b) => s + Number(b.BillAmount || 0),
        0,
      );
      setSelectedBills(rem);
      setData((d) => ({
        ...d,
        SelectedDemandAmount: d.SelectedDemandAmount - remAmount,
      }));
    }
  };

  useEffect(() => {
    const ids = currentBills.map((b) => b.DemandGenerationID);
    setSelectAll(
      ids.length > 0 && ids.every((id) => selectedBills.includes(id)),
    );
  }, [currentBills, selectedBills]);

  const handleUploadOrder = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (selectedBills.length === 0) {
      alert("Please select bill first!");
      return;
    }
    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
      alert(validation.message);
      e.target.value = "";
      return;
    }
    setUploadOrderFile(file);
    const updated = {};
    selectedBills.forEach((id) => {
      updated[id] = file;
    });
    setUploadedFiles((prev) => ({ ...prev, ...updated }));
  };

  const approveSelected = async () => {
    if (!selectedBills.length) {
      alert("No bills selected!");
      return;
    }
    if (AdminData.RoleID == 25 || AdminData.RoleID == 40) {
      const missing = selectedBills.filter((id) => !uploadedFiles[id]);
      if (missing.length) {
        alert("Please upload Fund Release Order for all selected bills!");
        return;
      }
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("selectedBills", JSON.stringify(selectedBills));
      Object.keys(uploadedFiles).forEach((id) => {
        formData.append(`uploadOrder_${id}`, uploadedFiles[id]);
      });
      const response = await ApproveBills(formData);
      if (response?.message) {
        alert(response.message);
      } else if (response?.error) {
        alert(response.error);
      }
      FetchData();
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("An error occurred while approving bills.");
    } finally {
      setLoading(false);
    }
  };

  // ── Deduction detail ──────────────────────────────────────────────────────
  const openDeductionDetail = async (id) => {
    try {
      const res = await Getyears("FetchDemandDeductionDetailbyBillID", id);
      setFetchDeductionDetail(res);
      setSelectedDemandID(id);
      setShowSpecific(2);
    } catch (err) {
      console.log(err);
    }
  };

  // ── Work name filter ───────────────────────────────────────────────────────
  const workNames = useMemo(() => {
    const seen = new Set();
    return ALLtableData.filter((item) => item.District === selectedDistrict)
      .map((v) => v.WorkName)
      .filter((w) => w && !seen.has(w) && seen.add(w));
  }, [ALLtableData, selectedDistrict]);

  // --> old code

  // useEffect(() => {
  //   if (!data.ProjectID || data.ProjectID === "All") {
  //     setTableData(
  //       ALLtableData.filter((b) =>
  //         selectedDistrict ? b.District === selectedDistrict : true,
  //       ),
  //     );
  //   } else {
  //     setTableData(ALLtableData.filter((b) => b.WorkName === data.ProjectID));
  //   }
  // }, [data.ProjectID]);

  useEffect(() => {
    let filtered = [...ALLtableData];

    if (data.ProjectID && data.ProjectID !== "All") {
      filtered = filtered.filter((item) => item.WorkName === data.ProjectID);
    }

    if (data.ApprovedYear) {
      filtered = filtered.filter(
        (item) => String(item.AAYear) === String(data.ApprovedYear),
      );
    }

    if (fromDate || toDate) {
      filtered = filtered.filter((item) => {
        if (!item.OldBillReceivedDate) return false;

        // Convert DD-MM-YYYY to Date
        const [day, month, year] = item.OldBillReceivedDate.split("-");

        const uploadDate = new Date(year, month - 1, day);
        uploadDate.setHours(0, 0, 0, 0);

        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        if (from) from.setHours(0, 0, 0, 0);
        if (to) to.setHours(23, 59, 59, 999);

        if (from && to) {
          return uploadDate >= from && uploadDate <= to;
        }

        if (from) {
          return uploadDate >= from;
        }

        if (to) {
          return uploadDate <= to;
        }

        return true;
      });
    }

    // 🔹 Taluka Filter
    if (selectedTaluka) {
      filtered = filtered.filter(
        (item) => (item.Taluka || item.ulb) === selectedTaluka
      );
    }


    // 🔹 Search Filter
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((bill) =>
        Object.values(bill).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }
    setTableData(filtered);
    setCurrentPage(1);
  }, [
    data.ProjectID,
    data.ApprovedYear,
    ALLtableData,
    fromDate,
    toDate,
    searchTerm,
    selectedTaluka
  ]);

  // ── Tally ─────────────────────────────────────────────────────────────────
  const selectedDetails = tableData.filter((b) =>
    selectedBills.includes(b.DemandGenerationID),
  );
  const selectedCount = selectedDetails.length;
  const selectedAmount = selectedDetails.reduce(
    (s, b) => s + Number(b.BillAmount || 0),
    0,
  );

  // ── Shared table header styles ─────────────────────────────────────────────
  const TH = ({ children, style = {} }) => (
    <th style={{ padding: "8px", minWidth: "130px", ...style }}>{children}</th>
  );

  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleDownloadPDF = async () => {
  const table = document.querySelector(".demandApprovalPdfTable");

  if (!table) {
    alert("Table not found");
    return;
  }

  try {
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2", // A2 for many columns
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const margin = 10;
    const titleHeight = 15;

    pdf.setFontSize(18);
    pdf.text(
      "Demand Approval Report",
      pageWidth / 2,
      10,
      { align: "center" }
    );

    const canvas = await html2canvas(table, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      scrollX: 0,
      scrollY: 0,
      windowWidth: table.scrollWidth,
    });

    const imgWidth = pageWidth - margin * 2;

    const pxToMm = imgWidth / canvas.width;

    const usableHeightMm =
      pageHeight - titleHeight - margin;

    const usableHeightPx =
      usableHeightMm / pxToMm;

    let renderedHeight = 0;
    let pageNumber = 0;

    while (renderedHeight < canvas.height) {
      const sliceHeight = Math.min(
        usableHeightPx,
        canvas.height - renderedHeight
      );

      const pageCanvas = document.createElement("canvas");
      const ctx = pageCanvas.getContext("2d");

      pageCanvas.width = canvas.width;
      pageCanvas.height = sliceHeight;

      ctx.drawImage(
        canvas,
        0,
        renderedHeight,
        canvas.width,
        sliceHeight,
        0,
        0,
        canvas.width,
        sliceHeight
      );

      const pageImg = pageCanvas.toDataURL(
        "image/jpeg",
        1.0
      );

      if (pageNumber > 0) {
        pdf.addPage();
      }

      pdf.addImage(
        pageImg,
        "JPEG",
        margin,
        titleHeight,
        imgWidth,
        sliceHeight * pxToMm
      );

      renderedHeight += sliceHeight;
      pageNumber++;
    }

    pdf.save("Demand_Approval_Report.pdf");
  } catch (err) {
    console.error(err);
    alert("PDF export failed");
  }
};


  const handleExportExcel = () => {
    const excelData = tableData.map((item, index) => ({
      "Sr No": index + 1,
      "Demand Number": item.DemandGenerationID,
      "Administrative Approved Year": item.AAYear,
      "Bank Name": item.Bank_Name,
      "Branch Name": item.Branch_Name,
      "IFSC Code": item.Bank_IFSC_Code,
      "Account Number": item.Bank_Account_Number,
      "Account Holder": item.Bank_Account_Holder_Name,
      "Class Of Work": item.GroupType,
      "Type Of Work": item.typeOfWork,
      "Work Name": item.WorkName,
      "Taluka": item.Taluka,
      "GR Date": item.GRDate,
      "MHUID Number": item.MHUID_Number,
      "Head Code": item.HeadCode,
      "Physical Progress": item.physicalValueOfProgress,
      "Bill Received Date": item.OldBillReceivedDate,
      "Bill Date": item.BillDate,
      "Bill Amount": item.BillAmount,
      "Net Payable Amount": item.NetPayableAmount,
      "Deduction Amount": item.DeductionAmount,
      "Vendor Name": item.Vendor_Company_Name,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    worksheet["!cols"] = [
      { wch: 10 },
      { wch: 20 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 20 },
      { wch: 25 },
      { wch: 20 },
      { wch: 20 },
      { wch: 50 },
      { wch: 20 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 25 },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Demand Approval"
    );

    XLSX.writeFile(
      workbook,
      `Demand_Approval_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  };

  // ── RENDER ────────────────────────────────────────────────────────────────
  return (
    <>
      {/* ══════════════════════════ DIVISION SUMMARY ══════════════════════ */}
      {showSpecific === 1 && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 4rem",
            }}
          >
            <h4
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                margin: 0,
              }}
            >
              <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
              {t("Old Pending Bill Inward")}
            </h4>
          </div>

          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              background: "white",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
            }}
          >
            <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
              {t("Division Summary")}
            </h4>
            <div style={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  textAlign: "center",
                  fontSize: "18px",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#1565c0", color: "white", fontSize: "18px" }}>
                    <th
                      rowSpan={2}
                      style={{ padding: "8px", minWidth: "50px" }}
                    >
                      {t("Sr No")}
                    </th>
                    <th
                      rowSpan={2}
                      style={{ padding: "8px", minWidth: "150px" }}
                    >
                      {t("Division")}
                    </th>
                    <th colSpan={2} style={{ padding: "8px" }}>
                      {t("Total Pending Bill")}
                    </th>
                    {AdminData?.Role === "RDD Checker(ASO)" && (
                      <th colSpan={2} style={{ padding: "8px" }}>
                        {t("RDD Checker(ASO)")}
                      </th>
                    )}
                    {AdminData?.Role === "RDD Section Officer" && (
                      <th colSpan={2} style={{ padding: "8px" }}>
                        {t("RDD Section Officer")}
                      </th>
                    )}
                  </tr>
                  <tr style={{ backgroundColor: "#1976d2", color: "white" }}>
                    <TH>{t("Count")}</TH>
                    <TH>{t("Amount")}</TH>
                    {(AdminData?.Role === "RDD Checker(ASO)" ||
                      AdminData?.Role === "RDD Section Officer") && (
                      <>
                        <TH>{t("Count")}</TH>
                        <TH>{t("Amount")}</TH>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {divisionSummary.length > 0 ? (
                    divisionSummary.map((item, i) => (
                      <tr
                        key={i}
                        style={{
                          fontSize: "18px",
                          cursor: "pointer",
                          backgroundColor: i % 2 === 0 ? "#f9f9f9" : "white",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#e3f2fd")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            i % 2 === 0 ? "#f9f9f9" : "white")
                        }
                        onClick={() => HandleDivisionClick(item.Division)}
                      >
                        <td style={{ padding: "8px" }}>{i + 1}</td>
                        <td
                          style={{
                            padding: "8px",
                            color: "#1976d2",
                            fontWeight: "600",
                          }}
                        >
                          {item.Division}
                        </td>
                        <td style={{ padding: "8px" }}>
                          {item.TotalPendingCount}
                        </td>
                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {Number(item.TotalPendingAmount).toLocaleString(
                            "en-IN",
                          )}
                        </td>
                        {AdminData?.Role === "RDD Checker(ASO)" && (
                          <>
                            <td style={{ padding: "8px" }}>
                              {item.RDDCheckerCount}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹{" "}
                              {Number(item.RDDCheckerAmount).toLocaleString(
                                "en-IN",
                              )}
                            </td>
                          </>
                        )}
                        {AdminData?.Role === "RDD Section Officer" && (
                          <>
                            <td style={{ padding: "8px" }}>
                              {item.RDDSOCount}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹{" "}
                              {Number(item.RDDSOAmount).toLocaleString("en-IN")}
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ padding: "20px", fontWeight: "bold" }}
                      >
                        {t("No data found !!")}
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  {(() => {
                    const tot = divisionSummary.reduce(
                      (a, item) => ({
                        TotalPendingCount:
                          a.TotalPendingCount +
                          Number(item.TotalPendingCount || 0),
                        TotalPendingAmount:
                          a.TotalPendingAmount +
                          Number(item.TotalPendingAmount || 0),
                        RDDCheckerCount:
                          a.RDDCheckerCount + Number(item.RDDCheckerCount || 0),
                        RDDCheckerAmount:
                          a.RDDCheckerAmount +
                          Number(item.RDDCheckerAmount || 0),
                        RDDSOCount: a.RDDSOCount + Number(item.RDDSOCount || 0),
                        RDDSOAmount:
                          a.RDDSOAmount + Number(item.RDDSOAmount || 0),
                      }),
                      {
                        TotalPendingCount: 0,
                        TotalPendingAmount: 0,
                        RDDCheckerCount: 0,
                        RDDCheckerAmount: 0,
                        RDDSOCount: 0,
                        RDDSOAmount: 0,
                      },
                    );
                    return (
                      <tr
                        style={{
                          backgroundColor: "#ccdef4",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        <td colSpan={2} style={{ padding: "8px" }}>
                          {t("Gross Total")}
                        </td>
                        <td style={{ padding: "8px" }}>
                          {tot.TotalPendingCount}
                        </td>
                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {Number(tot.TotalPendingAmount).toLocaleString(
                            "en-IN",
                          )}
                        </td>
                        {AdminData?.Role === "RDD Checker(ASO)" && (
                          <>
                            <td style={{ padding: "8px" }}>
                              {tot.RDDCheckerCount}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹{" "}
                              {Number(tot.RDDCheckerAmount).toLocaleString(
                                "en-IN",
                              )}
                            </td>
                          </>
                        )}
                        {AdminData?.Role === "RDD Section Officer" && (
                          <>
                            <td style={{ padding: "8px" }}>{tot.RDDSOCount}</td>
                            <td style={{ padding: "8px" }}>
                              ₹{" "}
                              {Number(tot.RDDSOAmount).toLocaleString("en-IN")}
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  })()}
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════ DISTRICT SUMMARY ══════════════════════ */}
      {showSpecific === 3 && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              padding: "10px 4rem",
            }}
          >
            <button
              className="btn btn-danger"
              onClick={() => setShowSpecific(1)}
            >
              {t("Back")}
            </button>
 
            <h4
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                margin: 0,
              }}
            >
              <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
              {t("District Summary")} — {selectedDivision}
            </h4>
          </div>

          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              background: "white",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",
            }}
          >
            <div style={{ overflowX: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  textAlign: "center",
                  fontSize: "18px",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#1565c0", color: "white", fontSize: "18px" }}>
                    <th
                      rowSpan={2}
                      style={{ padding: "8px", minWidth: "50px" }}
                    >
                      {t("Sr No")}
                    </th>
                    <th
                      rowSpan={2}
                      style={{ padding: "8px", minWidth: "150px" }}
                    >
                      {t("District")}
                    </th>
                    <th colSpan={2} style={{ padding: "8px" }}>
                      {t("Total Pending Bill")}
                    </th>
                    {AdminData?.Role === "RDD Checker(ASO)" && (
                      <th colSpan={2} style={{ padding: "8px" }}>
                        {t("RDD Checker(ASO)")}
                      </th>
                    )}
                    {AdminData?.Role === "RDD Section Officer" && (
                      <th colSpan={2} style={{ padding: "8px" }}>
                        {t("RDD Section Officer")}
                      </th>
                    )}
                  </tr>
                  <tr style={{ backgroundColor: "#1976d2", color: "white", fontSize: "18px" }}>
                    <TH>{t("Count")}</TH>
                    <TH>{t("Amount")}</TH>
                    {(AdminData?.Role === "RDD Checker(ASO)" ||
                      AdminData?.Role === "RDD Section Officer") && (
                      <>
                        <TH>{t("Count")}</TH>
                        <TH>{t("Amount")}</TH>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredDistricts.length > 0 ? (
                    filteredDistricts.map((item, i) => (
                      <tr
                        key={i}
                        style={{
                          fontSize: "18px",
                          cursor: "pointer",
                          backgroundColor: i % 2 === 0 ? "#f9f9f9" : "white",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#e3f2fd")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            i % 2 === 0 ? "#f9f9f9" : "white")
                        }
                        onClick={() => HandleDistrictClick(item.District)}
                      >
                        <td style={{ padding: "8px" }}>{i + 1}</td>
                        <td
                          style={{
                            padding: "8px",
                            color: "#1976d2",
                            fontWeight: "600",
                          }}
                        >
                          {t(item.District)}
                        </td>
                        <td style={{ padding: "8px" }}>
                          {item.TotalPendingCount}
                        </td>
                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {Number(item.TotalPendingAmount || 0).toLocaleString(
                            "en-IN",
                          )}
                        </td>
                        {AdminData?.Role === "RDD Checker(ASO)" && (
                          <>
                            <td style={{ padding: "8px" }}>
                              {item.RDDCheckerCount}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹{" "}
                              {Number(
                                item.RDDCheckerAmount || 0,
                              ).toLocaleString("en-IN")}
                            </td>
                          </>
                        )}
                        {AdminData?.Role === "RDD Section Officer" && (
                          <>
                            <td style={{ padding: "8px" }}>
                              {item.RDDSOCount}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹{" "}
                              {Number(item.RDDSOAmount || 0).toLocaleString(
                                "en-IN",
                              )}
                            </td>
                          </>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={6}
                        style={{ padding: "20px", fontWeight: "bold" }}
                      >
                        {t("No data found !!")}
                      </td>
                    </tr>
                  )}
                  {/* Footer total row */}
                  <tr
                    style={{
                      backgroundColor: "#e3f2fd",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    <td colSpan={2} style={{ padding: "10px" }}>
                      {t("Gross Total")}
                    </td>
                    <td style={{ padding: "10px" }}>
                      {filteredDistricts.reduce(
                        (s, i) => s + Number(i.TotalPendingCount || 0),
                        0,
                      )}
                    </td>
                    <td style={{ padding: "10px" }}>
                      ₹{" "}
                      {filteredDistricts
                        .reduce(
                          (s, i) => s + Number(i.TotalPendingAmount || 0),
                          0,
                        )
                        .toLocaleString("en-IN")}
                    </td>
                    {AdminData?.Role === "RDD Checker(ASO)" && (
                      <>
                        <td style={{ padding: "10px" }}>
                          {filteredDistricts.reduce(
                            (s, i) => s + Number(i.RDDCheckerCount || 0),
                            0,
                          )}
                        </td>
                        <td style={{ padding: "10px" }}>
                          ₹{" "}
                          {filteredDistricts
                            .reduce(
                              (s, i) => s + Number(i.RDDCheckerAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                      </>
                    )}
                    {AdminData?.Role === "RDD Section Officer" && (
                      <>
                        <td style={{ padding: "10px" }}>
                          {filteredDistricts.reduce(
                            (s, i) => s + Number(i.RDDSOCount || 0),
                            0,
                          )}
                        </td>
                        <td style={{ padding: "10px" }}>
                          ₹{" "}
                          {filteredDistricts
                            .reduce((s, i) => s + Number(i.RDDSOAmount || 0), 0)
                            .toLocaleString("en-IN")}
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════ BILL TABLE ════════════════════════════ */}
      {showSpecific === 0 && (
        <div
          className="col-12 DemandApprovalPage"
          style={{ backgroundColor: "#eff3f8" }}
        >
          {/* Header row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 4rem",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* Back to District summary for State users */}
              {AdminData?.Department_Name === "State" && (
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setShowSpecific(3);
                    setTableData([]);
                    setFromDate();
                    setToDate();
                  }}
                >
                  ← {t("Districts")}
                </button>
              )}
              <h4
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  margin: 0,
                }}
              >
                <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
                {t("Old Bill Approval")}
                {selectedDistrict && (
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#666",
                      marginLeft: "6px",
                    }}
                  >
                    ({selectedDistrict})
                  </span>
                )}
              </h4>
            </div>
            <button
              onClick={approveSelected}
              disabled={!selectedBills.length || loading}
              style={{
                border: "none",
                borderRadius: "20px",
                padding: "8px 20px",
                fontSize: "14px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor:
                  !selectedBills.length || loading ? "not-allowed" : "pointer",
                background: !selectedBills.length
                  ? "linear-gradient(to right, rgba(141,141,141,0.97))"
                  : "linear-gradient(to right, #3b409e, #0067ab, #0098d5)",
                color: "white",
              }}
            >
              <img
                src={ApprovePay32}
                style={{ width: "14px", filter: "brightness(0) invert(1)" }}
              />
              {loading ? t("Processing...") : t("Approve")}
            </button>
          </div>

          {/* Work Name filter */}
          <div
            className="col-12 my-3 px-4"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              className="col-12"
              style={{
                padding: "1px",
                borderRadius: "10px",
                background: "linear-gradient(to right, #2196f3, #9c27b0)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  background: "linear-gradient(to right, #c0e4f7, #cdd4f8)",
                  padding: "20px",
                  borderRadius: "8px",
                }}
              >
                <label style={{ fontWeight: "600", fontSize: "14px" }}>
                  {t("Work Name")}
                </label>
                <select
                  name="ProjectID"
                  value={data.ProjectID}
                  onChange={(e) =>
                    setData((d) => ({ ...d, ProjectID: e.target.value }))
                  }
                  style={{
                    padding: "10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    width: "830px",
                    fontSize: "18px",
                  }}
                >
                  <option value="All">{t("All Works")}</option>
                  {workNames.map((w, i) => (
                    <option key={i} value={w}>
                      {w}
                    </option>
                  ))}
                </select>

                <label
                  style={{
                    fontWeight: "600",
                    fontSize: "18px",
                    marginRight: "5px",
                  }}
                >
                  {t("Administrative Approved Year")}
                </label>

                <select
                  name="ApprovedYear"
                  value={data.ApprovedYear}
                  onChange={HandleChangeData}
                  style={{
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    outline: "none",
                    width: "250px",
                    fontSize: "18px",
                  }}
                >
                  <option value="">{t("Choose Approved Year")}</option>

                  {approvedYears.map((year, index) => (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Tally + Upload Order */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              margin: "0 20px 16px",
            }}
          >
            <table
              style={{
                borderCollapse: "collapse",
                background: "#fff",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
              }}
            >
              <thead>
                <tr style={{ background: "#1976d2", color: "#fff" }}>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                    No. of Bills
                  </th>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Total Bill Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    {selectedCount}
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    ₹ {selectedAmount.toLocaleString("en-IN")}
                  </td>
                </tr>
              </tbody>
            </table>

            {AdminData.Department_Name === "State" &&
              (AdminData.RoleID == 25 || AdminData.RoleID == 40) && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "12px 15px",
                    background: "#f8fafc",
                    borderRadius: "10px",
                    border: "1px solid #dbe4ee",
                  }}
                >
                  <label
                    style={{ fontSize: "18px", fontWeight: "600", margin: 0 }}
                  >
                    {t("Upload Fund Release Order")}
                  </label>
                  <input
                    type="file"
                    accept=".pdf,.xls,.xlsx"
                    onChange={handleUploadOrder}
                    style={{
                      border: "1px solid #cbd5e1",
                      padding: "6px",
                      borderRadius: "6px",
                      fontSize: "13px",
                    }}
                  />
                  {/* {uploadOrderFile && (
                    <span style={{ fontSize: "13px", fontWeight: "500" }}>
                      {uploadOrderFile.name}
                    </span>
                  )} */}
                </div>
              )}
          </div>
          {/* Date Filter */}
          <div style={{ display: "flex", gap: "8px", padding: "4px 1rem" }}>
            {/* <label className="form-label">Date</label> */}

            {/* Taluka Filter */}
            <div style={{ padding: "4px 0" }}>
              <select
                value={selectedTaluka}
                onChange={(e) => setSelectedTaluka(e.target.value)}
                style={{
                  width: "170px",
                  padding: "8px 12px",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f1f6fc",
                  fontSize: "13px",
                  height: "40px",
                }}
              >
                <option value="">Select Taluka</option>
 
                {[...new Set(
                  ALLtableData
                    ?.map((item) => item.Taluka || item.ulb)
                    .filter(Boolean)
                )]
                  .sort()
                  .map((taluka, index) => (
                    <option key={index} value={taluka}>
                      {taluka}
                    </option>
                  ))}
              </select>
            </div>

            <div className="d-flex gap-2">
              <div className="input-group" style={{ width: "170px" }}>
                <span className="input-group-text">From</span>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <div className="input-group" style={{ width: "170px" }}>
                <span className="input-group-text">To</span>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
            </div>

            {/* Search */}
            <div style={{ position: "relative", width: "220px" }}>
              <img
                src="/Search32.png"
                alt="Search"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  width: "16px",
                  opacity: 0.6,
                }}
              />
              <input
                type="text"
                placeholder={t("Search Here")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 12px 8px 32px",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f1f6fc",
                  fontSize: "13px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mb-3">
            <button
              className="btn btn-success"
              onClick={handleExportExcel}
            >
              Download Excel
            </button>

            <button
              className="btn btn-danger"
              onClick={handleDownloadPDF}
            >
              Download PDF
            </button>
          </div>
          {/* Bill table */}
          <div
            className="m-auto my-3"
            style={{
              width: "97%",
              background: "white",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 4px rgba(0,0,0,0.1)",

            }}
          >
            <h4 style={{ marginBottom: "18px", fontWeight: "bold" }}>
              {t("Bill Details")}
            </h4>
            {/* <div  className="demandApprovalPdfTable" style={{ overflowX: "visible" }}> */}
            <div
              className="demandApprovalPdfTable"
              style={{
                overflowX: "auto",
                width: "100%",
              }}
            >

              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  textAlign: "center",
                  fontSize: "18px"
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#1976d2",
                      color: "white",
                      fontSize: "11px",
                      fontSize: "18px"
                    }}
                  >
                    <th style={{ width: "4%", paddingInline: "4px" }}>
                      <input
                        type="checkbox"
                        style={{ height: "1.2rem", width: "1.4rem" }}
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                    </th>
                    <th style={{ minWidth: "50px", padding: "8px" }}>
                      {t("Sr No.")}
                    </th>
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Demand Number")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Administrative Approved Year")}
                    </th>

                    {/* Existing banking fields */}
                    {/* <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Amount Type")}
                    </th> */}

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      Bank Name
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Branch Name")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("IFSC Code")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Account Number")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Account Holder")}
                    </th>

                    {/* Missing fields added from first header */}
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Class Of Work")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Type Of Work")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Name")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      Taluka
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Approval GR Date")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("MHUID Number")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Head Code")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Physical Progress in Percentage")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Received Date")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Date")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Amount")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Net Payable Amount")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Deduction")}
                    </th>

                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Vendor Name")}
                    </th>

                    {/* <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Bill Copy")}
                    </th>
 
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Demand Copy")}
                    </th>
 
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Work Order Copy")}
                    </th>
 
                    <th style={{ minWidth: "130px", padding: "8px" }}>
                      {t("Administrative Approved GR (AAGR)")}
                    </th> */}

                    {AdminData.Department_Name == "State" &&
                      (AdminData.RoleID == 24 || AdminData.RoleID == 41) && (
                        <th style={{ minWidth: "130px", padding: "8px" }}>
                          {t("Fund Release Order")}
                        </th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {currentBills.length > 0 ? (
                    <>
                      {currentBills.map((val, idx) => (
                        <tr
                          key={idx}
                          style={{
                            fontSize: "18px",
                            backgroundColor:
                              idx % 2 === 0 ? "#f9f9f9" : "white",
                          }}
                        >
                          <td>
                            <input
                              type="checkbox"
                              style={{ height: "1.1rem", width: "1.1rem" }}
                              checked={selectedBills.includes(
                                val.DemandGenerationID,
                              )}
                              onChange={() =>
                                handleCheckboxChange(val.DemandGenerationID)
                              }
                            />
                          </td>
                          <td style={{ padding: "6px" }}>
                            {indexOfFirst + idx + 1}
                          </td>
                          <td>{val.DemandGenerationID}</td>

                          <td>{val.AAYear || "NA"}</td>

                          {/* <td>
                              ₹{" "}
                              {Number(val.NetPayableAmount).toLocaleString(
                                "en-IN",
                              )}
                            </td> */}

                          {/* <td>{val.TypeOfAmount}</td> */}

                          <td>{val.Bank_Name}</td>

                          <td>{val.Branch_Name}</td>

                          <td>{val.Bank_IFSC_Code}</td>

                          <td>{val.Bank_Account_Number}</td>

                          <td>{val.Bank_Account_Holder_Name}</td>

                          <td>{val.GroupType || "NA"}</td>

                          <td>{val.typeOfWork || val.workType || "NA"}</td>

                          <td
                            style={{
                              maxWidth: "300px",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {val.WorkName || "NA"}
                          </td>

                          <td>{val.Taluka || val.ulb || "NA"}</td>

                          <td>
                            {val.GRDate
                              ? val.GRDate.split("-").reverse().join("-")
                              : "NA"}
                          </td>

                          <td>{val.MHUID_Number || "NA"}</td>

                          <td>{val.HeadCode || "NA"}</td>

                          <td>
                            {val.physicalValueOfProgress ? (
                              <span
                                style={{
                                  color: "black",
                                  cursor: "pointer",
                                }}
                              // onClick={() =>
                              //   openProgressModal(
                              //     val.physicalprogressImage,
                              //     val.Location,
                              //   )
                              // }
                              >
                                {val.physicalValueOfProgress}%
                              </span>
                            ) : (
                              "NA"
                            )}
                          </td>

                          <td>
                            {val.OldBillReceivedDate
                              ? val.OldBillReceivedDate.split("-")
                                .reverse()
                                .join("-")
                              : "NA"}
                          </td>
                          <td>
                            {val.BillDate
                              ? val.BillDate.split("-").reverse().join("-")
                              : "NA"}
                          </td>
                          <td>{val.BillAmount || "NA"}</td>

                          <td>
                            ₹{" "}
                            {Number(val.NetPayableAmount || 0).toLocaleString(
                              "en-IN",
                            )}
                          </td>

                          <td
                          // onClick={() =>
                          //   DemandDeductionDetailByBillID(
                          //     val.DemandGenerationID,
                          //   )
                          // }
                          >
                            <p
                              className="my-auto"
                              style={{ textAlign: "center" }}
                            >
                              {val.DeductionAmount
                                ? Number(val.DeductionAmount).toLocaleString(
                                  "en-IN",
                                )
                                : "NA"}
                            </p>
                          </td>
                          <td>{val.Vendor_Company_Name}</td>

                          {/* <td>
                              {val.BillCopy ? (
                                <p className="my-auto">
                                  <a
                                    href={`${apiurl}/BillCopyDocsImages/${val.BillCopy}`}
                                    target="_blank"
                                  >
                                    {val.BillCopy}
                                  </a>
                                </p>
                              ) : (
                                "NA"
                              )}
                            </td>

                            <td>
                              {val.BillCopy ? (
                                <p className="my-auto">
                                  <a
                                    href={`${apiurl}/BillCopyDocsImages/${val.BillCopy}`}
                                    target="_blank"
                                  >
                                    {val.BillCopy}
                                  </a>
                                </p>
                              ) : (
                                "NA"
                              )}
                            </td>

                            <td>
                              {val.WorkCopy ? (
                                <p>
                                  <a
                                    href={`${apiurl}/WorkOrderDocsImages/${val.WorkCopy}`}
                                    target="_blank"
                                  >
                                    {val.WorkCopy}
                                  </a>
                                </p>
                              ) : (
                                "NA"
                              )}
                            </td>

                            <td>
                              {val.GRCopy ? (
                                <p>
                                  <a
                                    href={`${apiurl}/UploadedGR/${val.GRCopy}`}
                                    target="_blank"
                                  >
                                    {val.GRCopy}
                                  </a>
                                </p>
                              ) : (
                                "NA"
                              )}
                            </td> */}

                          {AdminData.Department_Name === "State" &&
                            (AdminData.RoleID == 24 ||
                              AdminData.RoleID == 41) && (
                              <td style={{ padding: "6px" }}>
                                {val.UploadWork ? (
                                  <a
                                    href={`${apiurl}/UploadWorkFiles/${val.UploadWork}`}
                                    target="_blank"
                                  >
                                    {val.UploadWork}
                                  </a>
                                ) : (
                                  <span
                                    className="text-danger fw-bold"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {t("No File")}
                                  </span>
                                )}
                              </td>
                            )}
                        </tr>
                      ))}
                      {/* Page total row */}
                      <tr
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          backgroundColor: "#f0f4ff",
                        }}
                      >
                        <td
                          colSpan={19}
                          style={{ textAlign: "right", padding: "8px" }}
                        >
                          Page Total
                        </td>
                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {currentBills
                            .reduce((s, b) => s + Number(b.BillAmount || 0), 0)
                            .toLocaleString("en-IN")}
                        </td>

                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {currentBills
                            .reduce(
                              (s, b) => s + Number(b.NetPayableAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {currentBills
                            .reduce(
                              (s, b) => s + Number(b.DeductionAmount || 0),
                              0,
                            )
                            .toLocaleString("en-IN")}
                        </td>
                        <td colSpan={4}></td>
                      </tr>
                      <tr
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          backgroundColor: "#f0f4ff",
                        }}
                      >
                        <td colSpan={19} style={{ textAlign: "right", padding: "8px" }}>
                          Gross Total
                        </td>

                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {tableData
                            .reduce((s, b) => s + Number(b.BillAmount || 0), 0)
                            .toLocaleString("en-IN")}
                        </td>

                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {tableData
                            .reduce((s, b) => s + Number(b.NetPayableAmount || 0), 0)
                            .toLocaleString("en-IN")}
                        </td>

                        <td style={{ padding: "8px" }}>
                          ₹{" "}
                          {tableData
                            .reduce((s, b) => s + Number(b.DeductionAmount || 0), 0)
                            .toLocaleString("en-IN")}
                        </td>

                        <td colSpan={4}></td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td
                        colSpan={14}
                        style={{ padding: "20px", fontWeight: "bold" }}
                      >
                        {t("No data found !!")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // padding: "0 2rem",
                height: "3rem",
                alignItems: "center",
              }}
            >
              <div>
                <p style={{ margin: 0 }}>
                  {t("Showing")} {tableData.length === 0 ? 0 : indexOfFirst + 1}{" "}
                  {t("to")} {Math.min(indexOfLast, tableData.length)} {t("of")}{" "}
                  {tableData.length} {t("entries")}
                </p>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <GooglePagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />

                <button
                  onClick={() => {
                    setShowAll(!showAll);
                    setCurrentPage(1);
                  }}
                  style={{
                    border: "none",
                    outline: "none",
                    cursor: "pointer",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#fff",
                    background: showAll
                      ? "linear-gradient(135deg, #28a745, #20c997)"
                      : "linear-gradient(135deg, #0067ab, #0098d5)",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {showAll ? "✓ Showing All" : "View All"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════ DEDUCTION DETAIL ══════════════════════ */}
      {showSpecific === 2 && selectedDemandID && (
        <div
          className="col-12"
          style={{
            backgroundColor: "#EFF3F8",
            minHeight: "90vh",
            padding: "20px",
          }}
        >
          <div className="col-11 m-auto">
            <button
              className="btn btn-danger px-3 rounded-4 mb-3"
              onClick={() => setShowSpecific(0)}
            >
              {t("Back")}
            </button>
            <h2
              style={{
                color: "#2C78DB",
                fontWeight: "700",
                fontSize: "1.3rem",
                marginBottom: "16px",
              }}
            >
              {t("Deduction Data of Bill")} — {selectedDemandID}
            </h2>
            <div
              style={{
                background: "white",
                padding: "30px",
                borderRadius: "16px",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
              }}
            >
              <div
                style={{
                  background: "#2C78DB",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    color: "white",
                  }}
                >
                  <thead>
                    <tr style={{ height: "3rem", fontSize: "12px" }}>
                      <th style={{ width: "10%", padding: "8px" }}>
                        {t("Sr No")}
                      </th>
                      <th style={{ width: "45%", padding: "8px" }}>
                        {t("Deduction Name")}
                      </th>
                      <th
                        style={{
                          width: "45%",
                          padding: "8px",
                          textAlign: "left",
                        }}
                      >
                        {t("Deduction Amount")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {fetchDeductionDetail.filter(
                      (i) => i.TypeOfAmount !== "Total Amount Payable",
                    ).length > 0 ? (
                      <>
                        {fetchDeductionDetail
                          .filter(
                            (i) => i.TypeOfAmount !== "Total Amount Payable",
                          )
                          .map((val, idx) => (
                            <tr
                              key={idx}
                              style={{
                                backgroundColor:
                                  idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                fontSize: "12px",
                                color: "#000",
                              }}
                            >
                              <td style={{ padding: "8px" }}>{idx + 1}</td>
                              <td style={{ padding: "8px" }}>
                                {val.TypeOfAmount}
                              </td>
                              <td style={{ padding: "8px", textAlign: "left" }}>
                                ₹ {Number(val.TotalAmount).toLocaleString()}
                              </td>
                            </tr>
                          ))}
                        <tr
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#f0f0f0",
                            color: "#000",
                          }}
                        >
                          <td colSpan={2} style={{ padding: "8px" }}>
                            {t("Total Deduction Amount")}
                          </td>
                          <td style={{ padding: "8px", textAlign: "left" }}>
                            ₹{" "}
                            {fetchDeductionDetail
                              .filter(
                                (i) =>
                                  i.TypeOfAmount !== "Total Amount Payable",
                              )
                              .reduce(
                                (acc, cur) =>
                                  acc + parseFloat(cur.TotalAmount || 0),
                                0,
                              )
                              .toLocaleString()}
                          </td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td
                          colSpan={3}
                          style={{ padding: "20px", color: "#000" }}
                        >
                          {t("No Data Found !!")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OldDemandApproval;

//-->old code

// import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
// import "./DemandApproval.css";
// import { apiurl } from "../../../../../path";
// import Application from "../../../StateContext/Application.js";
// import {
//   ApprovePay32,
//   BillApprovalBlue32,
// } from "../../../../../public/LoginImages/importimages.js";
// import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";
// import { jwtDecode } from "jwt-decode";
// import GooglePagination from "../../../styles/GooglePagination";

// // showSpecific values:
// //   0 = Bill table
// //   1 = Division summary  (State only)
// //   2 = Deduction detail  (any role)
// //   3 = District summary  (State only, after clicking a Division)

// const OldDemandApproval = () => {
//   const { t } = useLanguage();
//   const operation = useContext(Application);
//   const {
//     GetOldBillsApproval,
//     ApproveBills,
//     GetTotalAmountAvailbaleInBank,
//     Usermenu,
//     Getyears,
//     GetOldBillStateSummary, // ← new context function
//   } = operation;

//   // ── Auth ─────────────────────────────────────────────────────────────────
//   const [AdminData, setAdminData] = useState({});

//   useEffect(() => {
//     const token = localStorage.getItem("Token");
//     if (token) {
//       try {
//         setAdminData(jwtDecode(token));
//       } catch {}
//     }
//   }, []);

//   // ── Data ──────────────────────────────────────────────────────────────────
//   const [ALLtableData, setALLTableData] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const ALLtableDataRef = useRef([]);
//   useEffect(() => {
//     ALLtableDataRef.current = ALLtableData;
//   }, [ALLtableData]);

//   // Division / District summary (State roles)
//   const [districtSummary, setDistrictSummary] = useState([]);
//   const [selectedDivision, setSelectedDivision] = useState("");
//   const [selectedDistrict, setSelectedDistrict] = useState("");

//   // View state
//   const [showSpecific, setShowSpecific] = useState(0);
//   const [selectedDemandID, setSelectedDemandID] = useState(null);
//   const [fetchDeductionDetail, setFetchDeductionDetail] = useState([]);

//   // Selection
//   const [selectedBills, setSelectedBills] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [uploadedFiles, setUploadedFiles] = useState({});
//   const [uploadOrderFile, setUploadOrderFile] = useState(null);

//   // Misc
//   const [loading, setLoading] = useState(false);
//   const [BankBalance, setBankBalance] = useState({});
//   const [data, setData] = useState({
//     ProjectID: "",
//     SelectedDemandAmount: 0,
//   });
//   const [currentPage, setCurrentPage] = useState(1);
//   const billsPerPage = 10;
//   const totalPages = Math.ceil(tableData.length / billsPerPage);
//   const indexOfLast = currentPage * billsPerPage;
//   const indexOfFirst = indexOfLast - billsPerPage;
//   const currentBills = tableData.slice(indexOfFirst, indexOfLast);

//   // ── Derived: Division summary from districtSummary ───────────────────────
//   const divisionSummary = useMemo(() => {
//     const map = {};
//     districtSummary.forEach((item) => {
//       const div = item.Division || "Unknown";
//       if (!map[div])
//         map[div] = {
//           Division: div,
//           TotalPendingCount: 0,
//           TotalPendingAmount: 0,
//           RDDCheckerCount: 0,
//           RDDCheckerAmount: 0,
//           RDDSOCount: 0,
//           RDDSOAmount: 0,
//         };
//       map[div].TotalPendingCount += Number(item.TotalPendingCount || 0);
//       map[div].TotalPendingAmount += Number(item.TotalPendingAmount || 0);
//       map[div].RDDCheckerCount += Number(item.RDDCheckerCount || 0);
//       map[div].RDDCheckerAmount += Number(item.RDDCheckerAmount || 0);
//       map[div].RDDSOCount += Number(item.RDDSOCount || 0);
//       map[div].RDDSOAmount += Number(item.RDDSOAmount || 0);
//     });
//     return Object.values(map);
//   }, [districtSummary]);

//   const filteredDistricts = districtSummary.filter(
//     (d) => d.Division === selectedDivision,
//   );

//   // ── Fetch ─────────────────────────────────────────────────────────────────
//   const FetchData = async () => {
//     try {
//       const bills = await GetOldBillsApproval();
//       setALLTableData(bills);

//       if (AdminData?.Department_Name === "State") {
//         // Also fetch division/district summary
//         const summaryRes = await GetOldBillStateSummary();
//         setDistrictSummary(summaryRes?.message || []);
//         // State users start on Division summary view
//         setShowSpecific(1);
//       } else {
//         setTableData(bills);
//         setShowSpecific(0);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     const init = async () => {
//       try {
//         const res = await Usermenu();
//         setAdminData(res.Data);
//         const bal = await GetTotalAmountAvailbaleInBank();
//         setBankBalance(bal?.[0] || {});
//       } catch (err) {
//         console.log(err);
//       }
//     };
//     init();
//   }, []);

//   useEffect(() => {
//     if (AdminData?.Department_Name) FetchData();
//   }, [AdminData?.Department_Name]);

//   // ── Navigation ────────────────────────────────────────────────────────────
//   const HandleDivisionClick = (division) => {
//     setSelectedDivision(division);
//     setShowSpecific(3);
//   };

//   const HandleDistrictClick = (district) => {
//     setSelectedBills([]);
//     setSelectAll(false);
//     setCurrentPage(1);
//     setSelectedDistrict(district);
//     const filtered = ALLtableDataRef.current.filter(
//       (b) => b.District === district,
//     );
//     setTableData(filtered);
//     setShowSpecific(0);
//   };

//   // ── Select / Approve ──────────────────────────────────────────────────────
//   const handleCheckboxChange = (id) => {
//     const bill = tableData.find((b) => b.DemandGenerationID === id);
//     const amount = Number(bill?.BillAmount || 0);

//     setSelectedBills((prev) => {
//       const selectedObjs = tableData.filter((b) =>
//         prev.includes(b.DemandGenerationID),
//       );
//       if (prev.length > 0 && !prev.includes(id)) {
//         if (selectedObjs[0]?.District !== bill.District) {
//           alert("You can select bills from the same district only!");
//           return prev;
//         }
//       }
//       if (prev.includes(id)) {
//         setData((d) => ({
//           ...d,
//           SelectedDemandAmount: d.SelectedDemandAmount - amount,
//         }));
//         return prev.filter((x) => x !== id);
//       } else {
//         setData((d) => ({
//           ...d,
//           SelectedDemandAmount: d.SelectedDemandAmount + amount,
//         }));
//         return [...prev, id];
//       }
//     });
//   };

//   const handleSelectAllChange = (e) => {
//     const checked = e.target.checked;
//     let valid = currentBills;
//     if (AdminData.Department_Name === "State" && AdminData.RoleID !== 24) {
//       valid = currentBills.filter((b) => uploadedFiles[b.DemandGenerationID]);
//     }
//     if (checked && new Set(valid.map((b) => b.District)).size > 1) {
//       alert("Please select bills from the same district only!");
//       return;
//     }
//     const validIDs = valid.map((b) => b.DemandGenerationID);
//     setSelectAll(checked);
//     if (checked) {
//       const newSel = [...new Set([...selectedBills, ...validIDs])];
//       const newAmount = valid
//         .filter((b) => !selectedBills.includes(b.DemandGenerationID))
//         .reduce((s, b) => s + Number(b.BillAmount || 0), 0);
//       setSelectedBills(newSel);
//       setData((d) => ({
//         ...d,
//         SelectedDemandAmount: d.SelectedDemandAmount + newAmount,
//       }));
//     } else {
//       const rem = selectedBills.filter((id) => !validIDs.includes(id));
//       const remAmount = valid.reduce(
//         (s, b) => s + Number(b.BillAmount || 0),
//         0,
//       );
//       setSelectedBills(rem);
//       setData((d) => ({
//         ...d,
//         SelectedDemandAmount: d.SelectedDemandAmount - remAmount,
//       }));
//     }
//   };

//   useEffect(() => {
//     const ids = currentBills.map((b) => b.DemandGenerationID);
//     setSelectAll(
//       ids.length > 0 && ids.every((id) => selectedBills.includes(id)),
//     );
//   }, [currentBills, selectedBills]);

//   const handleUploadOrder = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (selectedBills.length === 0) {
//       alert("Please select bill first!");
//       return;
//     }
//     setUploadOrderFile(file);
//     const updated = {};
//     selectedBills.forEach((id) => {
//       updated[id] = file;
//     });
//     setUploadedFiles((prev) => ({ ...prev, ...updated }));
//   };

//   const approveSelected = async () => {
//     if (!selectedBills.length) {
//       alert("No bills selected!");
//       return;
//     }
//     if (AdminData.RoleID == 25) {
//       const missing = selectedBills.filter((id) => !uploadedFiles[id]);
//       if (missing.length) {
//         alert("Please upload Fund Release Order for all selected bills!");
//         return;
//       }
//     }
//     setLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append("selectedBills", JSON.stringify(selectedBills));
//       Object.keys(uploadedFiles).forEach((id) => {
//         formData.append(`uploadOrder_${id}`, uploadedFiles[id]);
//       });
//       const response = await ApproveBills(formData);
//       if (response?.message) {
//         alert(response.message);
//       } else if (response?.error) {
//         alert(response.error);
//       }
//       FetchData();
//       window.location.reload();
//     } catch (err) {
//       console.error(err);
//       alert("An error occurred while approving bills.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Deduction detail ──────────────────────────────────────────────────────
//   const openDeductionDetail = async (id) => {
//     try {
//       const res = await Getyears("FetchDemandDeductionDetailbyBillID", id);
//       setFetchDeductionDetail(res);
//       setSelectedDemandID(id);
//       setShowSpecific(2);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // ── Work name filter ───────────────────────────────────────────────────────
//   const workNames = useMemo(() => {
//     const seen = new Set();
//     return ALLtableData.map((v) => v.WorkName).filter(
//       (w) => w && !seen.has(w) && seen.add(w),
//     );
//   }, [ALLtableData]);

//   useEffect(() => {
//     if (!data.ProjectID || data.ProjectID === "All") {
//       setTableData(
//         ALLtableData.filter((b) =>
//           selectedDistrict ? b.District === selectedDistrict : true,
//         ),
//       );
//     } else {
//       setTableData(ALLtableData.filter((b) => b.WorkName === data.ProjectID));
//     }
//   }, [data.ProjectID]);

//   // ── Tally ─────────────────────────────────────────────────────────────────
//   const selectedDetails = tableData.filter((b) =>
//     selectedBills.includes(b.DemandGenerationID),
//   );
//   const selectedCount = selectedDetails.length;
//   const selectedAmount = selectedDetails.reduce(
//     (s, b) => s + Number(b.BillAmount || 0),
//     0,
//   );

//   // ── Shared table header styles ─────────────────────────────────────────────
//   const TH = ({ children, style = {} }) => (
//     <th style={{ padding: "8px", minWidth: "130px", ...style }}>{children}</th>
//   );

//   // ── RENDER ────────────────────────────────────────────────────────────────
//   return (
//     <>
//       {/* ══════════════════════════ DIVISION SUMMARY ══════════════════════ */}
//       {showSpecific === 1 && (
//         <div
//           className="col-12 DemandApprovalPage"
//           style={{ backgroundColor: "#eff3f8" }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               padding: "10px 4rem",
//             }}
//           >
//             <h4
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 margin: 0,
//               }}
//             >
//               <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
//               {t("Division Summary")} — {t("Old Bills")}
//             </h4>
//           </div>

//           <div
//             className="m-auto my-3"
//             style={{
//               width: "97%",
//               background: "white",
//               borderRadius: "10px",
//               padding: "20px",
//               boxShadow: "0 0 4px rgba(0,0,0,0.1)",
//             }}
//           >
//             <div style={{ overflowX: "auto" }}>
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   textAlign: "center",
//                   fontSize: "11px",
//                 }}
//               >
//                 <thead>
//                   <tr style={{ backgroundColor: "#1565c0", color: "white" }}>
//                     <th
//                       rowSpan={2}
//                       style={{ padding: "8px", minWidth: "50px" }}
//                     >
//                       {t("Sr No")}
//                     </th>
//                     <th
//                       rowSpan={2}
//                       style={{ padding: "8px", minWidth: "150px" }}
//                     >
//                       {t("Division")}
//                     </th>
//                     <th colSpan={2} style={{ padding: "8px" }}>
//                       {t("Total Pending Bill")}
//                     </th>
//                     {AdminData?.Role === "RDD Checker(ASO)" && (
//                       <th colSpan={2} style={{ padding: "8px" }}>
//                         {t("RDD Checker(ASO)")}
//                       </th>
//                     )}
//                     {AdminData?.Role === "RDD Section Officer" && (
//                       <th colSpan={2} style={{ padding: "8px" }}>
//                         {t("RDD Section Officer")}
//                       </th>
//                     )}
//                   </tr>
//                   <tr style={{ backgroundColor: "#1976d2", color: "white" }}>
//                     <TH>{t("Count")}</TH>
//                     <TH>{t("Amount")}</TH>
//                     {(AdminData?.Role === "RDD Checker(ASO)" ||
//                       AdminData?.Role === "RDD Section Officer") && (
//                       <>
//                         <TH>{t("Count")}</TH>
//                         <TH>{t("Amount")}</TH>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {divisionSummary.length > 0 ? (
//                     divisionSummary.map((item, i) => (
//                       <tr
//                         key={i}
//                         style={{
//                           fontSize: "10px",
//                           cursor: "pointer",
//                           backgroundColor: i % 2 === 0 ? "#f9f9f9" : "white",
//                         }}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.backgroundColor = "#e3f2fd")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.backgroundColor =
//                             i % 2 === 0 ? "#f9f9f9" : "white")
//                         }
//                         onClick={() => HandleDivisionClick(item.Division)}
//                       >
//                         <td style={{ padding: "8px" }}>{i + 1}</td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             color: "#1976d2",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {item.Division}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           {item.TotalPendingCount}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           ₹{" "}
//                           {Number(item.TotalPendingAmount).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>
//                         {AdminData?.Role === "RDD Checker(ASO)" && (
//                           <>
//                             <td style={{ padding: "8px" }}>
//                               {item.RDDCheckerCount}
//                             </td>
//                             <td style={{ padding: "8px" }}>
//                               ₹{" "}
//                               {Number(item.RDDCheckerAmount).toLocaleString(
//                                 "en-IN",
//                               )}
//                             </td>
//                           </>
//                         )}
//                         {AdminData?.Role === "RDD Section Officer" && (
//                           <>
//                             <td style={{ padding: "8px" }}>
//                               {item.RDDSOCount}
//                             </td>
//                             <td style={{ padding: "8px" }}>
//                               ₹{" "}
//                               {Number(item.RDDSOAmount).toLocaleString("en-IN")}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={6}
//                         style={{ padding: "20px", fontWeight: "bold" }}
//                       >
//                         {t("No data found !!")}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//                 <tfoot>
//                   {(() => {
//                     const tot = divisionSummary.reduce(
//                       (a, item) => ({
//                         TotalPendingCount:
//                           a.TotalPendingCount +
//                           Number(item.TotalPendingCount || 0),
//                         TotalPendingAmount:
//                           a.TotalPendingAmount +
//                           Number(item.TotalPendingAmount || 0),
//                         RDDCheckerCount:
//                           a.RDDCheckerCount + Number(item.RDDCheckerCount || 0),
//                         RDDCheckerAmount:
//                           a.RDDCheckerAmount +
//                           Number(item.RDDCheckerAmount || 0),
//                         RDDSOCount: a.RDDSOCount + Number(item.RDDSOCount || 0),
//                         RDDSOAmount:
//                           a.RDDSOAmount + Number(item.RDDSOAmount || 0),
//                       }),
//                       {
//                         TotalPendingCount: 0,
//                         TotalPendingAmount: 0,
//                         RDDCheckerCount: 0,
//                         RDDCheckerAmount: 0,
//                         RDDSOCount: 0,
//                         RDDSOAmount: 0,
//                       },
//                     );
//                     return (
//                       <tr
//                         style={{
//                           backgroundColor: "#ccdef4",
//                           fontWeight: "bold",
//                           fontSize: "11px",
//                         }}
//                       >
//                         <td colSpan={2} style={{ padding: "8px" }}>
//                           {t("Total")}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           {tot.TotalPendingCount}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           ₹{" "}
//                           {Number(tot.TotalPendingAmount).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>
//                         {AdminData?.Role === "RDD Checker(ASO)" && (
//                           <>
//                             <td style={{ padding: "8px" }}>
//                               {tot.RDDCheckerCount}
//                             </td>
//                             <td style={{ padding: "8px" }}>
//                               ₹{" "}
//                               {Number(tot.RDDCheckerAmount).toLocaleString(
//                                 "en-IN",
//                               )}
//                             </td>
//                           </>
//                         )}
//                         {AdminData?.Role === "RDD Section Officer" && (
//                           <>
//                             <td style={{ padding: "8px" }}>{tot.RDDSOCount}</td>
//                             <td style={{ padding: "8px" }}>
//                               ₹{" "}
//                               {Number(tot.RDDSOAmount).toLocaleString("en-IN")}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     );
//                   })()}
//                 </tfoot>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══════════════════════════ DISTRICT SUMMARY ══════════════════════ */}
//       {showSpecific === 3 && (
//         <div
//           className="col-12 DemandApprovalPage"
//           style={{ backgroundColor: "#eff3f8" }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "10px 4rem",
//             }}
//           >
//             <h4
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "5px",
//                 margin: 0,
//               }}
//             >
//               <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
//               {t("District Summary")} — {selectedDivision}
//             </h4>
//             <button
//               className="btn btn-danger"
//               onClick={() => setShowSpecific(1)}
//             >
//               {t("Back")}
//             </button>
//           </div>

//           <div
//             className="m-auto my-3"
//             style={{
//               width: "97%",
//               background: "white",
//               borderRadius: "10px",
//               padding: "20px",
//               boxShadow: "0 0 4px rgba(0,0,0,0.1)",
//             }}
//           >
//             <div style={{ overflowX: "auto" }}>
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   textAlign: "center",
//                   fontSize: "11px",
//                 }}
//               >
//                 <thead>
//                   <tr style={{ backgroundColor: "#1565c0", color: "white" }}>
//                     <th
//                       rowSpan={2}
//                       style={{ padding: "8px", minWidth: "50px" }}
//                     >
//                       {t("Sr No")}
//                     </th>
//                     <th
//                       rowSpan={2}
//                       style={{ padding: "8px", minWidth: "150px" }}
//                     >
//                       {t("District")}
//                     </th>
//                     <th colSpan={2} style={{ padding: "8px" }}>
//                       {t("Total Pending Bill")}
//                     </th>
//                     {AdminData?.Role === "RDD Checker(ASO)" && (
//                       <th colSpan={2} style={{ padding: "8px" }}>
//                         {t("RDD Checker(ASO)")}
//                       </th>
//                     )}
//                     {AdminData?.Role === "RDD Section Officer" && (
//                       <th colSpan={2} style={{ padding: "8px" }}>
//                         {t("RDD Section Officer")}
//                       </th>
//                     )}
//                   </tr>
//                   <tr style={{ backgroundColor: "#1976d2", color: "white" }}>
//                     <TH>{t("Count")}</TH>
//                     <TH>{t("Amount")}</TH>
//                     {(AdminData?.Role === "RDD Checker(ASO)" ||
//                       AdminData?.Role === "RDD Section Officer") && (
//                       <>
//                         <TH>{t("Count")}</TH>
//                         <TH>{t("Amount")}</TH>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredDistricts.length > 0 ? (
//                     filteredDistricts.map((item, i) => (
//                       <tr
//                         key={i}
//                         style={{
//                           fontSize: "10px",
//                           cursor: "pointer",
//                           backgroundColor: i % 2 === 0 ? "#f9f9f9" : "white",
//                         }}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.backgroundColor = "#e3f2fd")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.backgroundColor =
//                             i % 2 === 0 ? "#f9f9f9" : "white")
//                         }
//                         onClick={() => HandleDistrictClick(item.District)}
//                       >
//                         <td style={{ padding: "8px" }}>{i + 1}</td>
//                         <td
//                           style={{
//                             padding: "8px",
//                             color: "#1976d2",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {item.District}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           {item.TotalPendingCount}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           ₹{" "}
//                           {Number(item.TotalPendingAmount || 0).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>
//                         {AdminData?.Role === "RDD Checker(ASO)" && (
//                           <>
//                             <td style={{ padding: "8px" }}>
//                               {item.RDDCheckerCount}
//                             </td>
//                             <td style={{ padding: "8px" }}>
//                               ₹{" "}
//                               {Number(
//                                 item.RDDCheckerAmount || 0,
//                               ).toLocaleString("en-IN")}
//                             </td>
//                           </>
//                         )}
//                         {AdminData?.Role === "RDD Section Officer" && (
//                           <>
//                             <td style={{ padding: "8px" }}>
//                               {item.RDDSOCount}
//                             </td>
//                             <td style={{ padding: "8px" }}>
//                               ₹{" "}
//                               {Number(item.RDDSOAmount || 0).toLocaleString(
//                                 "en-IN",
//                               )}
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={6}
//                         style={{ padding: "20px", fontWeight: "bold" }}
//                       >
//                         {t("No data found !!")}
//                       </td>
//                     </tr>
//                   )}
//                   {/* Footer total row */}
//                   <tr
//                     style={{
//                       backgroundColor: "#e3f2fd",
//                       fontWeight: "bold",
//                       fontSize: "11px",
//                     }}
//                   >
//                     <td colSpan={2} style={{ padding: "10px" }}>
//                       {t("Total")}
//                     </td>
//                     <td style={{ padding: "10px" }}>
//                       {filteredDistricts.reduce(
//                         (s, i) => s + Number(i.TotalPendingCount || 0),
//                         0,
//                       )}
//                     </td>
//                     <td style={{ padding: "10px" }}>
//                       ₹{" "}
//                       {filteredDistricts
//                         .reduce(
//                           (s, i) => s + Number(i.TotalPendingAmount || 0),
//                           0,
//                         )
//                         .toLocaleString("en-IN")}
//                     </td>
//                     {AdminData?.Role === "RDD Checker(ASO)" && (
//                       <>
//                         <td style={{ padding: "10px" }}>
//                           {filteredDistricts.reduce(
//                             (s, i) => s + Number(i.RDDCheckerCount || 0),
//                             0,
//                           )}
//                         </td>
//                         <td style={{ padding: "10px" }}>
//                           ₹{" "}
//                           {filteredDistricts
//                             .reduce(
//                               (s, i) => s + Number(i.RDDCheckerAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                       </>
//                     )}
//                     {AdminData?.Role === "RDD Section Officer" && (
//                       <>
//                         <td style={{ padding: "10px" }}>
//                           {filteredDistricts.reduce(
//                             (s, i) => s + Number(i.RDDSOCount || 0),
//                             0,
//                           )}
//                         </td>
//                         <td style={{ padding: "10px" }}>
//                           ₹{" "}
//                           {filteredDistricts
//                             .reduce((s, i) => s + Number(i.RDDSOAmount || 0), 0)
//                             .toLocaleString("en-IN")}
//                         </td>
//                       </>
//                     )}
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══════════════════════════ BILL TABLE ════════════════════════════ */}
//       {showSpecific === 0 && (
//         <div
//           className="col-12 DemandApprovalPage"
//           style={{ backgroundColor: "#eff3f8" }}
//         >
//           {/* Header row */}
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               padding: "10px 4rem",
//             }}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               {/* Back to District summary for State users */}
//               {AdminData?.Department_Name === "State" && (
//                 <button
//                   className="btn btn-secondary btn-sm"
//                   onClick={() => {
//                     setShowSpecific(3);
//                     setTableData([]);
//                   }}
//                 >
//                   ← {t("Districts")}
//                 </button>
//               )}
//               <h4
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "5px",
//                   margin: 0,
//                 }}
//               >
//                 <img src={BillApprovalBlue32} style={{ width: "1.5rem" }} />
//                 {t("Old Bill Approval")}
//                 {selectedDistrict && (
//                   <span
//                     style={{
//                       fontSize: "13px",
//                       color: "#666",
//                       marginLeft: "6px",
//                     }}
//                   >
//                     ({selectedDistrict})
//                   </span>
//                 )}
//               </h4>
//             </div>
//             <button
//               onClick={approveSelected}
//               disabled={!selectedBills.length || loading}
//               style={{
//                 border: "none",
//                 borderRadius: "20px",
//                 padding: "8px 20px",
//                 fontSize: "14px",
//                 fontWeight: "600",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 cursor:
//                   !selectedBills.length || loading ? "not-allowed" : "pointer",
//                 background: !selectedBills.length
//                   ? "linear-gradient(to right, rgba(141,141,141,0.97))"
//                   : "linear-gradient(to right, #3b409e, #0067ab, #0098d5)",
//                 color: "white",
//               }}
//             >
//               <img
//                 src={ApprovePay32}
//                 style={{ width: "14px", filter: "brightness(0) invert(1)" }}
//               />
//               {loading ? t("Processing...") : t("Approve")}
//             </button>
//           </div>

//           {/* Work Name filter */}
//           <div
//             className="col-12 my-3 px-4"
//             style={{ display: "flex", justifyContent: "center" }}
//           >
//             <div
//               className="col-12"
//               style={{
//                 padding: "1px",
//                 borderRadius: "10px",
//                 background: "linear-gradient(to right, #2196f3, #9c27b0)",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   background: "linear-gradient(to right, #c0e4f7, #cdd4f8)",
//                   padding: "20px",
//                   borderRadius: "8px",
//                 }}
//               >
//                 <label style={{ fontWeight: "600", fontSize: "14px" }}>
//                   {t("Work Name")}
//                 </label>
//                 <select
//                   name="ProjectID"
//                   value={data.ProjectID}
//                   onChange={(e) =>
//                     setData((d) => ({ ...d, ProjectID: e.target.value }))
//                   }
//                   style={{
//                     padding: "10px",
//                     borderRadius: "6px",
//                     border: "1px solid #ccc",
//                     width: "830px",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <option value="All">{t("All Works")}</option>
//                   {workNames.map((w, i) => (
//                     <option key={i} value={w}>
//                       {w}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>

//           {/* Tally + Upload Order */}
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "flex-start",
//               margin: "0 20px 16px",
//             }}
//           >
//             <table
//               style={{
//                 borderCollapse: "collapse",
//                 background: "#fff",
//                 boxShadow: "0 0 5px rgba(0,0,0,0.1)",
//               }}
//             >
//               <thead>
//                 <tr style={{ background: "#1976d2", color: "#fff" }}>
//                   <th style={{ border: "1px solid #ccc", padding: "8px" }}>
//                     No. of Bills
//                   </th>
//                   <th style={{ border: "1px solid #ccc", padding: "8px" }}>
//                     Total Bill Amount
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td style={{ border: "1px solid #ccc", padding: "8px" }}>
//                     {selectedCount}
//                   </td>
//                   <td style={{ border: "1px solid #ccc", padding: "8px" }}>
//                     ₹ {selectedAmount.toLocaleString("en-IN")}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>

//             {AdminData.Department_Name === "State" &&
//               AdminData.RoleID == 25 && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "10px",
//                     padding: "12px 15px",
//                     background: "#f8fafc",
//                     borderRadius: "10px",
//                     border: "1px solid #dbe4ee",
//                   }}
//                 >
//                   <label
//                     style={{ fontSize: "14px", fontWeight: "600", margin: 0 }}
//                   >
//                     {t("Upload Fund Release Order")}
//                   </label>
//                   <input
//                     type="file"
//                     accept=".pdf,.xls,.xlsx"
//                     onChange={handleUploadOrder}
//                     style={{
//                       border: "1px solid #cbd5e1",
//                       padding: "6px",
//                       borderRadius: "6px",
//                       fontSize: "13px",
//                     }}
//                   />
//                   {uploadOrderFile && (
//                     <span style={{ fontSize: "13px", fontWeight: "500" }}>
//                       {uploadOrderFile.name}
//                     </span>
//                   )}
//                 </div>
//               )}
//           </div>

//           {/* Bill table */}
//           <div
//             className="m-auto my-3"
//             style={{
//               width: "97%",
//               background: "white",
//               borderRadius: "10px",
//               padding: "20px",
//               boxShadow: "0 0 4px rgba(0,0,0,0.1)",
//             }}
//           >
//             <h4 style={{ marginBottom: "15px", fontWeight: "bold" }}>
//               {t("Bill Details")}
//             </h4>
//             <div style={{ overflowX: "auto" }}>
//               <table
//                 style={{
//                   width: "100%",
//                   borderCollapse: "collapse",
//                   textAlign: "center",
//                 }}
//               >
//                 <thead>
//                   <tr
//                     style={{
//                       backgroundColor: "#1976d2",
//                       color: "white",
//                       fontSize: "11px",
//                     }}
//                   >
//                     <th style={{ padding: "8px" }}>
//                       <input
//                         type="checkbox"
//                         style={{ height: "1.2rem", width: "1.2rem" }}
//                         checked={selectAll}
//                         onChange={handleSelectAllChange}
//                       />
//                     </th>
//                     <th style={{ minWidth: "45px", padding: "8px" }}>
//                       {t("Sr No.")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Demand No.")}
//                     </th>
//                     <th style={{ minWidth: "200px", padding: "8px" }}>
//                       {t("Work Name")}
//                     </th>
//                     <th style={{ minWidth: "100px", padding: "8px" }}>
//                       {t("District")}
//                     </th>
//                     <th style={{ minWidth: "100px", padding: "8px" }}>
//                       {t("Taluka")}
//                     </th>
//                     <th style={{ minWidth: "130px", padding: "8px" }}>
//                       {t("Beneficiary Name")}
//                     </th>
//                     <th style={{ minWidth: "120px", padding: "8px" }}>
//                       {t("Bill Amount")}
//                     </th>
//                     <th style={{ minWidth: "110px", padding: "8px" }}>
//                       {t("Deduction")}
//                     </th>
//                     <th style={{ minWidth: "110px", padding: "8px" }}>
//                       {t("Net Amount")}
//                     </th>
//                     <th style={{ minWidth: "100px", padding: "8px" }}>
//                       {t("A.A. Year")}
//                     </th>
//                     <th style={{ minWidth: "100px", padding: "8px" }}>
//                       {t("Bill Date")}
//                     </th>
//                     <th style={{ minWidth: "100px", padding: "8px" }}>
//                       {t("Head Code")}
//                     </th>
//                     {AdminData.Department_Name === "State" &&
//                       AdminData.RoleID == 24 && (
//                         <th style={{ minWidth: "130px", padding: "8px" }}>
//                           {t("Fund Release Order")}
//                         </th>
//                       )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentBills.length > 0 ? (
//                     <>
//                       {currentBills.map((val, idx) => (
//                         <tr
//                           key={idx}
//                           style={{
//                             fontSize: "10px",
//                             backgroundColor:
//                               idx % 2 === 0 ? "#f9f9f9" : "white",
//                           }}
//                         >
//                           <td>
//                             <input
//                               type="checkbox"
//                               style={{ height: "1.1rem", width: "1.1rem" }}
//                               checked={selectedBills.includes(
//                                 val.DemandGenerationID,
//                               )}
//                               onChange={() =>
//                                 handleCheckboxChange(val.DemandGenerationID)
//                               }
//                             />
//                           </td>
//                           <td style={{ padding: "6px" }}>
//                             {indexOfFirst + idx + 1}
//                           </td>
//                           <td style={{ padding: "6px" }}>
//                             {val.DemandGenerationID}
//                           </td>
//                           <td style={{ padding: "6px", textAlign: "left" }}>
//                             {val.WorkName}
//                           </td>
//                           <td style={{ padding: "6px" }}>{val.District}</td>
//                           <td style={{ padding: "6px" }}>{val.Taluka}</td>
//                           <td style={{ padding: "6px" }}>
//                             {val.BeneficiaryName}
//                           </td>
//                           <td style={{ padding: "6px" }}>
//                             ₹{" "}
//                             {Number(val.BillAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}
//                           </td>
//                           <td style={{ padding: "6px" }}>
//                             ₹{" "}
//                             {Number(val.DeductionAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}
//                           </td>
//                           <td style={{ padding: "6px" }}>
//                             ₹{" "}
//                             {Number(val.NetPayableAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}
//                           </td>
//                           <td style={{ padding: "6px" }}>{val.AAYear}</td>
//                           <td style={{ padding: "6px" }}>{val.BillDate}</td>
//                           <td style={{ padding: "6px" }}>{val.HeadCode}</td>
//                           {AdminData.Department_Name === "State" &&
//                             AdminData.RoleID == 24 && (
//                               <td style={{ padding: "6px" }}>
//                                 {val.UploadWork ? (
//                                   <a
//                                     href={`${apiurl}/UploadWorkFiles/${val.UploadWork}`}
//                                     target="_blank"
//                                   >
//                                     {val.UploadWork}
//                                   </a>
//                                 ) : (
//                                   <span
//                                     className="text-danger fw-bold"
//                                     style={{ fontSize: "12px" }}
//                                   >
//                                     {t("No File")}
//                                   </span>
//                                 )}
//                               </td>
//                             )}
//                         </tr>
//                       ))}
//                       {/* Page total row */}
//                       <tr
//                         style={{
//                           fontWeight: "bold",
//                           fontSize: "11px",
//                           backgroundColor: "#f0f4ff",
//                         }}
//                       >
//                         <td
//                           colSpan={7}
//                           style={{ textAlign: "right", padding: "8px" }}
//                         >
//                           Page Total
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           ₹{" "}
//                           {currentBills
//                             .reduce((s, b) => s + Number(b.BillAmount || 0), 0)
//                             .toLocaleString("en-IN")}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           ₹{" "}
//                           {currentBills
//                             .reduce(
//                               (s, b) => s + Number(b.DeductionAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                         <td style={{ padding: "8px" }}>
//                           ₹{" "}
//                           {currentBills
//                             .reduce(
//                               (s, b) => s + Number(b.NetPayableAmount || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>
//                         <td colSpan={4}></td>
//                       </tr>
//                     </>
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={14}
//                         style={{ padding: "20px", fontWeight: "bold" }}
//                       >
//                         {t("No data found !!")}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 padding: "0 2rem",
//                 height: "3rem",
//                 alignItems: "center",
//               }}
//             >
//               <p style={{ margin: 0 }}>
//                 {t("Showing")} {tableData.length === 0 ? 0 : indexOfFirst + 1}{" "}
//                 {t("to")} {Math.min(indexOfLast, tableData.length)} {t("of")}{" "}
//                 {tableData.length} {t("entries")}
//               </p>
//               <GooglePagination
//                 currentPage={currentPage}
//                 totalPages={totalPages}
//                 onPageChange={setCurrentPage}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══════════════════════════ DEDUCTION DETAIL ══════════════════════ */}
//       {showSpecific === 2 && selectedDemandID && (
//         <div
//           className="col-12"
//           style={{
//             backgroundColor: "#EFF3F8",
//             minHeight: "90vh",
//             padding: "20px",
//           }}
//         >
//           <div className="col-11 m-auto">
//             <button
//               className="btn btn-danger px-3 rounded-4 mb-3"
//               onClick={() => setShowSpecific(0)}
//             >
//               {t("Back")}
//             </button>
//             <h2
//               style={{
//                 color: "#2C78DB",
//                 fontWeight: "700",
//                 fontSize: "1.3rem",
//                 marginBottom: "16px",
//               }}
//             >
//               {t("Deduction Data of Bill")} — {selectedDemandID}
//             </h2>
//             <div
//               style={{
//                 background: "white",
//                 padding: "30px",
//                 borderRadius: "16px",
//                 boxShadow: "0 0 5px rgba(0,0,0,0.1)",
//               }}
//             >
//               <div
//                 style={{
//                   background: "#2C78DB",
//                   borderRadius: "8px",
//                   overflow: "hidden",
//                 }}
//               >
//                 <table
//                   style={{
//                     width: "100%",
//                     borderCollapse: "collapse",
//                     color: "white",
//                   }}
//                 >
//                   <thead>
//                     <tr style={{ height: "3rem", fontSize: "12px" }}>
//                       <th style={{ width: "10%", padding: "8px" }}>
//                         {t("Sr No")}
//                       </th>
//                       <th style={{ width: "45%", padding: "8px" }}>
//                         {t("Deduction Name")}
//                       </th>
//                       <th
//                         style={{
//                           width: "45%",
//                           padding: "8px",
//                           textAlign: "left",
//                         }}
//                       >
//                         {t("Deduction Amount")}
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {fetchDeductionDetail.filter(
//                       (i) => i.TypeOfAmount !== "Total Amount Payable",
//                     ).length > 0 ? (
//                       <>
//                         {fetchDeductionDetail
//                           .filter(
//                             (i) => i.TypeOfAmount !== "Total Amount Payable",
//                           )
//                           .map((val, idx) => (
//                             <tr
//                               key={idx}
//                               style={{
//                                 backgroundColor:
//                                   idx % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
//                                 fontSize: "12px",
//                                 color: "#000",
//                               }}
//                             >
//                               <td style={{ padding: "8px" }}>{idx + 1}</td>
//                               <td style={{ padding: "8px" }}>
//                                 {val.TypeOfAmount}
//                               </td>
//                               <td style={{ padding: "8px", textAlign: "left" }}>
//                                 ₹ {Number(val.TotalAmount).toLocaleString()}
//                               </td>
//                             </tr>
//                           ))}
//                         <tr
//                           style={{
//                             fontWeight: "bold",
//                             backgroundColor: "#f0f0f0",
//                             color: "#000",
//                           }}
//                         >
//                           <td colSpan={2} style={{ padding: "8px" }}>
//                             {t("Total Deduction Amount")}
//                           </td>
//                           <td style={{ padding: "8px", textAlign: "left" }}>
//                             ₹{" "}
//                             {fetchDeductionDetail
//                               .filter(
//                                 (i) =>
//                                   i.TypeOfAmount !== "Total Amount Payable",
//                               )
//                               .reduce(
//                                 (acc, cur) =>
//                                   acc + parseFloat(cur.TotalAmount || 0),
//                                 0,
//                               )
//                               .toLocaleString()}
//                           </td>
//                         </tr>
//                       </>
//                     ) : (
//                       <tr>
//                         <td
//                           colSpan={3}
//                           style={{ padding: "20px", color: "#000" }}
//                         >
//                           {t("No Data Found !!")}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default OldDemandApproval;
